import './style.scss';

import upload from './js/Upload';

export default function () {
	$.nette.ext('custom-upload', {
		init: function () {
			upload(document);

			this.ext('snippets', true).after(($el) => {
				if ($el.get(0)) {
					upload($el.get(0));
				}
			});
		}
	});
}
